import { render, staticRenderFns } from "./NotUsed.vue?vue&type=template&id=64b515e3&scoped=true"
import script from "./NotUsed.vue?vue&type=script&lang=js"
export * from "./NotUsed.vue?vue&type=script&lang=js"
import style0 from "./NotUsed.vue?vue&type=style&index=0&id=64b515e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b515e3",
  null
  
)

export default component.exports